import { Ventilation } from './Ventilation'

export class CaseVentilation {
  constructor (
    public ventilator?: Ventilation,
    public position?: CaseVentilationPosition,
    public size?: number,
  ) { }

  static fromJson (json: Record<string, any>): CaseVentilation {
    return new CaseVentilation(
      json.ventilator ? Ventilation.fromJson(json.ventilator) : undefined,
      json.position,
      json.size,
    )
  }

  public toJson (): Record<string, any> {
    return {
      ventilator: this.ventilator ? this.ventilator.toJson() : undefined,
      position: this.position,
      size: this.size,
    }
  }

  public get label (): string {
    if (this.ventilator)
      return this.ventilator.label.replaceAll('+', '+ <br/>')
    return 'SKM'
  }

  public get ventilatorDepth (): number {
    if (this.ventilator)
      return this.ventilator.depth
    return 0
  }

  public get gridDepth (): number {
    return 150
  }
}

export enum CaseVentilationPosition {
  frontTop = 1,
  frontBottom = 2,
  frontLeftTop = 7,
  frontRightTop = 8,
  frontLeftBottom = 9,
  frontRightBottom = 10,
}

export const skm30Price = 4000
export const skm45Price = 5000
export const skm90Price = 6000
